import { View, Text } from '@react-pdf/renderer';
import { tableStyle } from './style';
import { convertIsoToDiffDaysWithoutWeekendsAndHolidays } from '../../../util/date/dateHelper';
import { HolidayDto } from '../../../commonTypes/organization.types';
import { DateTime } from 'luxon';

interface ITable {
    filteredRequests: Array<any>;
    totalDays: number;
    holidays: HolidayDto[];
    userInfo?: any;
}

export const Table = ({ filteredRequests, totalDays, holidays, userInfo }: ITable) => {
    const showUserColumn = !userInfo;

    return (
        <View style={tableStyle.table}>
            <View fixed>
                <View style={tableStyle.tableHeaderRow}>
                    <Text style={tableStyle.headerNumber}> </Text>
                    {showUserColumn && <Text style={tableStyle.headerUser}>User</Text>}
                    <Text style={tableStyle.headerPolicy}>Policy</Text>
                    <Text style={tableStyle.headerPeriod}>Period</Text>
                    <Text style={tableStyle.headerStatus}>Status</Text>
                    <Text style={tableStyle.headerDays}>Days</Text>
                </View>
            </View>

            {filteredRequests.map((request, index) => {
                const fromDate = new Date(request.fromDate);
                const toDate = new Date(request.toDate);
                const days = convertIsoToDiffDaysWithoutWeekendsAndHolidays(request.fromDate, request.toDate, holidays, request.leaveDurationType);

                return (
                    <View key={index} style={tableStyle.tableRow}>
                        <Text style={tableStyle.rowNumber}>{index + 1}.</Text>
                        {showUserColumn && (
                            <Text style={tableStyle.rowUser}>
                                {request.givenName} {request.familyName}
                            </Text>
                        )}
                        <Text style={tableStyle.rowPolicy}>{request.policyType}</Text>
                        <Text style={tableStyle.rowPeriod}>
                            {`${DateTime.fromJSDate(fromDate).toFormat('dd/MM/yyyy')} - ${DateTime.fromJSDate(toDate).toFormat('dd/MM/yyyy')}`}
                        </Text>

                        <Text style={tableStyle.rowStatus}>{request.status}</Text>
                        <Text style={tableStyle.rowDays}>{days}</Text>
                    </View>
                );
            })}

            <View style={tableStyle.totalRow}>
                <Text>Total Days: </Text>
                <Text>{totalDays}</Text>
            </View>
        </View>
    );
};
